import { actionTypes as asyncTypes, isAsyncOperation, isAsyncComplete, isAsyncFailure } from 'async-ops';
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../../common_components/mdae-framework";
import { DELETE_COMMENT_CATEGORY } from '../services/delete-comment-category';
import { SAVE_CATEGORY } from '../services/save-category';
import { EDIT_COMMENT_CATEGORY } from '../services/edit-comment-category';
import { GET_CATEGORIES } from '../services/get-categories';
import { GET_COMMENT_CATEGORIES } from "../services/get-comment-categories";
import { INSERT_NEW_COMMENT_CATEGORY } from '../services/insert-new-comment-category';
import { GET_CATEGORY_REFERENCE_DATA } from '../services/get-category-reference-data';
import { GET_TASK_CATEGORY_LINKED_DATA } from '../services/get-task-category-linked-data';
import { DELETE_CATEGORY } from '../services/delete-category';
import { format } from 'date-fns';
import { isEqual } from 'lodash';
export const TOGGLE_CATEGORY_LIST_POPUP = 'TOGGLE_CATEGORY_LIST_POPUP';
export const TOGGLE_CATEGORY_DATA_GRID_ACTION_POPOVER = 'TOGGLE_CATEGORY_DATA_GRID_ACTION_POPOVER';
export const TOGGLE_COMMENT_CATEGORY_DETAIL_POPUP = 'TOGGLE_COMMENT_CATEGORY_DETAIL_POPUP';
export const TOGGLE_CATEGORY_DETAIL_WARNING_POPUP = 'TOGGLE_CATEGORY_DETAIL_WARNING_POPUP';
export const SET_COMMENT_CATEGORY_DATA = 'SET_COMMENT_CATEGORY_DATA';
export const RESET_COMMENT_CATEGORY_POPUP_VALIDATION = 'RESET_COMMENT_CATEGORY_POPUP_VALIDATION';
export const RESET_CATEGORY_POPUP_VALIDATION = 'RESET_CATEGORY_POPUP_VALIDATION';
export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export const TOGGLE_CATEGORY_DETAIL_POPUP = 'TOGGLE_CATEGORY_DETAIL_POPUP';
export const SET_CATEGORY_DETAIL_END_DATE = 'SET_CATEGORY_DETAIL_END_DATE';
export const REFRESH_CATEGORY_GRID = 'REFRESH_CATEGORY_GRID';
export const SET_COMMENT_CATEGORY_FIELD_DATA = 'SET_COMMENT_CATEGORY_FIELD_DATA';
export const SET_TASK_TEMPLATES_FOR_MODULE_REMOVAL_WARNING = 'SET_TASK_TEMPLATES_FOR_MODULE_REMOVAL_WARNING';
export const SET_DENIAL_REASON_CATEGORY_LINKED_DATA = 'SET_DENIAL_REASON_CATEGORY_LINKED_DATA';
export const SET_REMIT_ADJUSTMENT_CODES ='SET_REMIT_ADJUSTMENT_CODES';
const initialError = {
  code: '',
  message: '',
  value: []
};

export const CategoryData = {
  categoryName: '',
  CategoryId: 0
}
export const categoryGridSelection = {
  mode: "single",
  showCheckBoxesMode: "always",
  selectAllMode: "allPages",
}
export const initialCommentCategoryData = {
  categoryName: null,
  entityType: null,
  effectiveDate: new Date(),
  endDate: '',
  description: '',
  categoryId: 0
}
export const initialCategoryData = {
  categoryName: null,
  effectiveDate: new Date(),
  endDate: '',
  description: '',
  categoryId: 0,
  displayAlias: null,
  moduleType: '',
  categoryType: '',
  curatedInd: false,
  isDisabled: false,
  categoryArea: '',
  moduleTypeList: [],
  isCategoryUsed: false
}
const initialTaskCategoryLinkedData = {
  attachedAuditPathways: [],
  attachedTaskTemplates: [],
  denialReasonsAttachedToCategory:[]
}

const initialState = {
  loading: false,
  refreshCategoryGrid: false,
  error: initialError,
  isCategoryGridCheckboxesVisible: false,
  categoryGridSelection,
  commentCategoryList: [],
  commentCategoryData: initialCommentCategoryData,
  categoryData: initialCategoryData,
  taskCategoryLinkedData: initialTaskCategoryLinkedData,
  isCommentCategoryDataValid: true,
  isCategoryDataValid: true,
  moduleTypeList: [],
  remitAdjustmentReasonCodes:[]
};
export default (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      //get
      if (isAsyncOperation(GET_COMMENT_CATEGORIES)(action) ||
        isAsyncOperation(GET_CATEGORIES)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_COMMENT_CATEGORIES)(action) ||
        isAsyncComplete(GET_CATEGORIES)(action)) {
        return { ...state, refreshCategoryGrid: false, loading: false };
      }
      if (isAsyncFailure(GET_COMMENT_CATEGORIES)(action) ||
        isAsyncFailure(GET_CATEGORIES)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //edit
      if (isAsyncOperation(EDIT_COMMENT_CATEGORY)(action) ||
        isAsyncOperation(SAVE_CATEGORY)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(EDIT_COMMENT_CATEGORY)(action) ||
        isAsyncComplete(SAVE_CATEGORY)(action)) {
        return { ...state, refreshCategoryGrid: true, loading: false };
      }
      if (isAsyncFailure(EDIT_COMMENT_CATEGORY)(action) ||
        isAsyncFailure(SAVE_CATEGORY)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //insert
      if (isAsyncOperation(INSERT_NEW_COMMENT_CATEGORY)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(INSERT_NEW_COMMENT_CATEGORY)(action)) {
        return { ...state, refreshCategoryGrid: true, loading: false };
      }
      if (isAsyncFailure(INSERT_NEW_COMMENT_CATEGORY)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      //delete
      if (isAsyncOperation(DELETE_COMMENT_CATEGORY)(action) ||
        isAsyncOperation(DELETE_CATEGORY)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(DELETE_COMMENT_CATEGORY)(action) ||
        isAsyncComplete(DELETE_CATEGORY)(action)) {
        return { ...state, refreshCategoryGrid: true, loading: false };
      }
      if (isAsyncFailure(DELETE_COMMENT_CATEGORY)(action) ||
        isAsyncFailure(DELETE_CATEGORY)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      if (isAsyncOperation(GET_CATEGORY_REFERENCE_DATA)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_CATEGORY_REFERENCE_DATA)(action)) {
        return { ...state, moduleTypeList: action.response.workflowModuleTypes, remitAdjustmentReasonCodes: action.response.remitAdjustmentReasonCodes,loading: false };
      }
      if (isAsyncFailure(GET_CATEGORY_REFERENCE_DATA)(action)) {
        return { ...state, loading: false, error: action.error };
      }

      if (isAsyncOperation(GET_TASK_CATEGORY_LINKED_DATA)(action)) {
        return { ...state, loading: true };
      }
      if (isAsyncComplete(GET_TASK_CATEGORY_LINKED_DATA)(action)) {
        return {
          ...state, taskCategoryLinkedData: {
            attachedAuditPathways: action.response.attachedAuditPathways,
            attachedTaskTemplates: action.response.attachedTaskTemplates,
            denialReasonsAttachedToCategory:action.response.denialReasonsAttachedToCategory
          }, loading: false
        };
      }
      if (isAsyncFailure(GET_TASK_CATEGORY_LINKED_DATA)(action)) {
        return { ...state, loading: false, error: action.error };
      }
      return state;

    case SET_CATEGORY_DETAIL_END_DATE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, categoryData: { ...newState.categoryData, ...action.data } };
      }
      return newState;
    case SET_COMMENT_CATEGORY_FIELD_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, commentCategoryData: { ...newState.commentCategoryData, ...action.data } };
      }
      return newState;
    case SET_COMMENT_CATEGORY_DATA:
    case TOGGLE_COMMENT_CATEGORY_DETAIL_POPUP:
    case TOGGLE_CATEGORY_DATA_GRID_ACTION_POPOVER:
    case RESET_COMMENT_CATEGORY_POPUP_VALIDATION:
    case TOGGLE_CATEGORY_DETAIL_POPUP:
    case RESET_CATEGORY_POPUP_VALIDATION:
    case TOGGLE_CATEGORY_DETAIL_WARNING_POPUP:
    case SET_CATEGORY_DATA:
    case SET_TASK_TEMPLATES_FOR_MODULE_REMOVAL_WARNING:
    case SET_REMIT_ADJUSTMENT_CODES:
          newState = { ...state };
          if (action.data.commentCategoryData != undefined && action.data.commentCategoryData.effectiveDate instanceof Date) {
              const parsedDate = new Date(action.data.commentCategoryData.effectiveDate);
              const now = new Date();
              parsedDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
              action.data.commentCategoryData.effectiveDate = parsedDate;
          }
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;

    case REFRESH_CATEGORY_GRID:
      return { ...state, refreshCategoryGrid: true }

    default:
      return state;
  }
};

export const formatCategoryDetailObjectToSave = (
  categoryDetailFormData,
  allModuleTypeList
) => {
  if (categoryDetailFormData.moduleTypeList?.length === allModuleTypeList?.length
    && isEqual(categoryDetailFormData.moduleTypeList.slice(0).sort(), allModuleTypeList.slice(0).sort())) {
    categoryDetailFormData.moduleTypeList = null;
  }
  categoryDetailFormData.effectiveDate = format(
    new Date(categoryDetailFormData.effectiveDate),
    "MM/DD/YYYY"
  );
  if (categoryDetailFormData.endDate)
    categoryDetailFormData.endDate = format(
      new Date(categoryDetailFormData.endDate),
      "MM/DD/YYYY"
    );
  delete categoryDetailFormData.createDate;
  delete categoryDetailFormData.updateDate;
  return categoryDetailFormData;
};
export const formatCommentCatagoryObjectToSave = (commentCategoryData) =>{
  if (!commentCategoryData?.applicationId)
    commentCategoryData.applicationId = 'MDAE';

  delete commentCategoryData.createDate;
  delete commentCategoryData.updateDate;
  return commentCategoryData;
}

